module.exports = __webpack_public_path__ + "img/mobile-to-web-icon.348c5b7.svg";